import { ClientBookmark } from "../../domain/model/client_bookmark";
import { Company } from "../../domain/model/company";
import { Customer } from "../../domain/model/customer";
import { JobCareer } from "../../domain/model/job_career";
import { PastCaseProject } from "../../domain/model/past_case_project";
import { TJobCareerWithCustomerID } from "../../domain/repository/job_career_repository";
import { TOccupationCounts } from "../type/common";

interface IGetCustomerResponse {
  customer?: Customer;
  jobCareer?: JobCareer[];
  postCaseProjects?: PastCaseProject[];
  company?: Company;
}
class GetCustomerResponse implements IGetCustomerResponse {
  public customer: Customer;
  public jobCareer: JobCareer[];
  public postCaseProjects: PastCaseProject[];
  public company: Company;
}

interface IGetCustomersByClientTopPageResponse {
  customers?: Customer[];
  clientBookmarks?: ClientBookmark[];
  jobCareersWithCustomerID?: TJobCareerWithCustomerID[];
  occupationCounts?: TOccupationCounts;
}
class GetCustomersByClientTopPageResponse
  implements IGetCustomersByClientTopPageResponse
{
  public customers: Customer[];
  public clientBookmarks: ClientBookmark[];
  public jobCareersWithCustomerID: TJobCareerWithCustomerID[];
  public occupationCounts: TOccupationCounts;
}

interface IGetMeCustomerByCustomerTopPageResponse {
  customer?: Customer;
  jobCareers?: JobCareer[];
}
class GetMeCustomerByCustomerTopPageResponse
  implements IGetMeCustomerByCustomerTopPageResponse
{
  public customer: Customer;
  public jobCareers: JobCareer[];
  public pastCaseProjects: PastCaseProject[];
}

interface IGetCustomersByClientPmCampaignPageResponse {
  pmCustomers?: Customer[];
  toBPmCustomers?: Customer[];
  toCPmCustomers?: Customer[];
  bizdevPmCustomers?: Customer[];
  growthPmCustomers?: Customer[];
  pmmCustomers?: Customer[];
  poCustomers?: Customer[];
  clientBookmarks?: ClientBookmark[];
  jobCareersWithCustomerID?: TJobCareerWithCustomerID[];
  occupationCounts?: TOccupationCounts;
}
class GetCustomersByClientPmCampaignPageResponse
  implements IGetCustomersByClientPmCampaignPageResponse
{
  public pmCustomers: Customer[];
  public toBPmCustomers: Customer[];
  public toCPmCustomers: Customer[];
  public bizdevPmCustomers: Customer[];
  public growthPmCustomers: Customer[];
  public pmmCustomers: Customer[];
  public poCustomers: Customer[];
  public clientBookmarks: ClientBookmark[];
  public jobCareersWithCustomerID: TJobCareerWithCustomerID[];
  public occupationCounts: TOccupationCounts;
}

interface IGetCustomersByClientSalesCampaignPageResponse {
  salesStrategyCustomers?: Customer[];
  cooCustomers?: Customer[];
  kpiCustomers?: Customer[];
  partnerSalesCustomers?: Customer[];
  allianceCustomers?: Customer[];
  salesOrgDevCustomers?: Customer[];
  sfaCrmCustomers?: Customer[];
  salesEnablementCustomers?: Customer[];
  salesDxCustomers?: Customer[];
  insideSalesCustomers?: Customer[];
  customerSuccessCustomers?: Customer[];
  ltvCustomers?: Customer[];
  groupSalesCustomers?: Customer[];
  interDeptCustomers?: Customer[];
  crossSellCustomers?: Customer[];
  clientBookmarks?: ClientBookmark[];
  jobCareersWithCustomerID?: TJobCareerWithCustomerID[];
}
class GetCustomersByClientSalesCampaignPageResponse
  implements IGetCustomersByClientSalesCampaignPageResponse
{
  public salesStrategyCustomers: Customer[];
  public cooCustomers: Customer[];
  public kpiCustomers: Customer[];
  public partnerSalesCustomers: Customer[];
  public allianceCustomers: Customer[];
  public salesOrgDevCustomers: Customer[];
  public sfaCrmCustomers: Customer[];
  public salesEnablementCustomers: Customer[];
  public salesDxCustomers: Customer[];
  public insideSalesCustomers: Customer[];
  public customerSuccessCustomers: Customer[];
  public ltvCustomers: Customer[];
  public groupSalesCustomers: Customer[];
  public interDeptCustomers: Customer[];
  public crossSellCustomers: Customer[];
  public clientBookmarks: ClientBookmark[];
  public jobCareersWithCustomerID: TJobCareerWithCustomerID[];
}

interface IGetCustomersByClientIpoCampaignPageResponse {
  ipoPrepCustomers?: Customer[];
  internalControlCustomers?: Customer[];
  auditCustomers?: Customer[];
  securitiesAuditCustomers?: Customer[];
  fundraisingCustomers?: Customer[];
  irStrategyCustomers?: Customer[];
  investorRelationsCustomers?: Customer[];
  materialsCustomers?: Customer[];
  globalCustomers?: Customer[];
  cfoCustomers?: Customer[];
  clientBookmarks?: ClientBookmark[];
  jobCareersWithCustomerID?: TJobCareerWithCustomerID[];
}
class GetCustomersByClientIpoCampaignPageResponse
  implements IGetCustomersByClientIpoCampaignPageResponse
{
  public ipoPrepCustomers: Customer[];
  public internalControlCustomers: Customer[];
  public auditCustomers: Customer[];
  public securitiesAuditCustomers: Customer[];
  public fundraisingCustomers: Customer[];
  public irStrategyCustomers: Customer[];
  public investorRelationsCustomers: Customer[];
  public materialsCustomers: Customer[];
  public globalCustomers: Customer[];
  public cfoCustomers: Customer[];
  public clientBookmarks: ClientBookmark[];
  public jobCareersWithCustomerID: TJobCareerWithCustomerID[];
}

export {
  GetCustomerResponse,
  GetCustomersByClientPmCampaignPageResponse,
  GetCustomersByClientSalesCampaignPageResponse,
  GetCustomersByClientIpoCampaignPageResponse,
  GetCustomersByClientTopPageResponse,
  GetMeCustomerByCustomerTopPageResponse,
};



// WEBPACK FOOTER //
// ./src/presentation/response/customer_response.ts